export const routes = {
    "/:taskId/immunisationVaccinationConsultationNotes": {
        title: "Vaccination Consultation Notes"
    },
    "/:taskId/bbvVaccinationConsultationNotes": {
        title: "Consultation Notes"
    },
    "/:taskId/immunisationVaccinationConsultationNotesPrint": {
        title: "Vaccination Consultation Notes"
    }
};
